import { Link } from "wouter";
import { Code2, Link2, Lock, Users } from "lucide-react";
import { useDashboard } from "@/features/dashboard/dashboard-context";
import { EnvironmentBadge, KybLock, PageHead, Panel } from "@/components/bits";
import { useI18n } from "@/i18n/i18n-context";

const MODULE_ICONS = {
  equipe: Users,
  developpeurs: Code2,
  liens: Link2,
};

export default function LockedModule({
  module,
}: {
  module: "equipe" | "developpeurs" | "liens";
}) {
  const { t, dict } = useI18n();
  const d = useDashboard();
  const Icon = MODULE_ICONS[module];
  const modInfo = dict.locked.modules[module] || {
    title: module,
    desc: "",
  };

  return (
    <>
      <PageHead title={modInfo.title} sub={modInfo.desc}>
        <EnvironmentBadge />
      </PageHead>
      <Panel>
        {d.isBusiness ? (
          <KybLock what={t("locked.moduleWhat", { title: modInfo.title })} />
        ) : (
          <div className="flex flex-col items-start gap-3 p-2">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent text-primary">
              <Icon className="h-5 w-5" />
            </span>
            <p className="font-bold">{t("locked.businessOnlyTitle")}</p>
            <p className="max-w-lg text-sm text-muted-foreground">
              {t("locked.businessOnlyDesc")}
            </p>
            <Link
              href="/accounts"
              className="inline-flex items-center gap-1.5 rounded-md bg-primary px-3 py-1.5 text-xs font-semibold text-primary-foreground transition hover:brightness-110"
            >
              <Lock className="h-3.5 w-3.5" />
              {t("locked.createBusinessBtn")}
            </Link>
          </div>
        )}
      </Panel>
    </>
  );
}
